export const APIREQUEST = 'APIREQUEST';

// auth types
export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const SIGNOUT = 'SIGNOUT';
export const USER_DETAILS = 'USER_DETAILS';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASS_ERROR = 'FORGOT_PASS_ERROR';
export const AUTH_ERROR = 'AUTH_ERROR';
export const ERROR = 'ERROR';
export const ON_LOAD = 'ON_LOAD';
export const TOKEN_REQUEST = 'TOKEN_REQUEST';
export const REFRESH_ACCESS_TOKEN = 'REFRESH_ACCESS_TOKEN';
export const TOKEN_RECEIVED = 'TOKEN_RECEIVED';
export const TOKEN_FAILURE = 'TOKEN_FAILURE';
export const NEW_TOKEN_RECEIVED = 'NEW_TOKEN_RECEIVED';
export const NEW_TOKEN_FAILURE = 'NEW_TOKEN_FAILURE';
